"use client";

import React, { Suspense } from "react";
import { BlocksProps } from "@/lib/wordpress/_types/blocksStyle";
import displayBlock from "@/lib/wordpress/blocks/displayBlock";
import { useGlobalContext } from "@/lib/globalContext";
import { useEffect } from "react";
import { replaceNewsletterWidget } from "../Newsletter/replaceNewsletterWidget";

// Rendered inside the footer's Suspense boundary, so its effect only runs once
// the footer blocks have hydrated. Replacing #newsletter-widget earlier changes
// DOM that React still has to hydrate (React #418/#422).
const NewsletterMount = () => {
  useEffect(() => {
    replaceNewsletterWidget({
      klaviyoListId: process.env.NEXT_PUBLIC_KLAVIYO_LIST_ID,
    });
  }, []);
  return null;
};

const Footer = () => {
  const state = useGlobalContext();
  const { footer } = state;
  return (
    <footer id="site-footer">
      <Suspense>
        {!!footer?.blocks?.length &&
          footer?.blocks?.map((block: BlocksProps, index: number) => {
            return displayBlock(block, index);
          })}
        {!!footer?.blocks?.length && <NewsletterMount />}
      </Suspense>
    </footer>
  );
};

export default Footer;
